import React from 'react'
import { AgTechButton, AgTechClickEventHandler } from '../../Buttons/AgTechButtons'
import { AgTechStandardModal } from './AgTechModal'

export type AgTechHelpModalProps = {
    title: string,
    content: React.ReactNode,
    width?: string,
    classes?: string
}

const AgTechHelpModal = (props: AgTechHelpModalProps) => (
    <AgTechStandardModal
        title={props.title}
        body={() => <>{props.content}</>}
    />
);

AgTechHelpModal.Open = (e: AgTechClickEventHandler, props: AgTechHelpModalProps) =>
    e.modals.showModal({
        content: () => <AgTechHelpModal {...props} />,
        width: props.width ?? '560px',
        classes: props.classes
    });

AgTechHelpModal.Button = (props: AgTechHelpModalProps) => (
    <AgTechButton
        icon='bi bi-info-circle'
        tooltip='Help'
        classes={`border-0 !bg-transparent !shadow-none text-detail hover:text-highlight px-1 py-1 ${props.classes ?? ''}`}
        action={e => AgTechHelpModal.Open(e, props)}
    />
);

export default AgTechHelpModal;
